export default __webpack_public_path__ + "static/media/ag-grey.3b7e3c4a.svg";